export const SIDE_NAVBAR_WIDTH = '54px'
